import React from 'react';

export default ref => {
  const [clickOutside, setClickOutside] = React.useState(false);
  React.useEffect(() => {
    function handleClickOutside(event) {
      if (event.target.placeholder != 'dd.mm.yyyy') {
        setClickOutside(true);
      } else {
        setClickOutside(false);
      }
    }
    // Bind the event listener
    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [ref]);

  return clickOutside;
};
